import { render } from "./Tools.vue?vue&type=template&id=5b7b3fe1"
import script from "./Tools.vue?vue&type=script&lang=ts"
export * from "./Tools.vue?vue&type=script&lang=ts"
script.render = render

export default script